<template>
  <div class="company-info-card">
    <div style="display: flex; flex-direction: column; gap: 1rem; align-items: center;">
      <b-avatar
        class="company-info-card--avatar avatar"
        :src="logoUrl ? logoUrl : ''"
        :text="$gettext('No logo')"
        size="8rem"
      />
      <div v-if="controlPanelCustomerCompany.is_premium">
        <GkBadge
          v-if="subscriptionDuration > 1"
          :text="$gettext('Premium')"
          account-badge no-shadow
          :tooltip-text="$gettext('Your client has a yearly Premium subscription. He will receive a 30% discount and you will receive a yearly referral fee of €10. Every year for as long as your client stays connected.')"
          type="premium"
        />
        <GkBadge
          v-if="subscriptionDuration <= 1"
          :text="$gettext('Premium')"
            no-shadow
          :tooltip-text="$gettext('This client has a monthly Premium subscription but does not take advantage of your 30% discount and you do not receive a referral fee. If your client switches to a yearly subscription, not only will he receive a 30% discount but you will also receive a yearly referral fee of €10.')"
          type="premium"
          variant="brand-ghost"
        />
      </div>

      <div v-if="!controlPanelCustomerCompany.is_premium">
        <GkBadge
          :text="$gettext('Basic')"
          account-badge no-shadow
          :tooltipText="$gettext('This client has a Basic account and you will not receive a referral fee. If this person upgrades to a yearly Premium account, your client receives a 30% discount while you will receive a yearly referral fee of €10. Try to upgrade your client.')"
          type="basic"
        />
      </div>
    </div>

    <div class="company-info-card--contentwrap">
      <div class="company-info-card--companyname">
        <h2>{{ customerDetails.name }}</h2>
        <div class="sector">{{ sectorText }}</div>
      </div>
      <div class="company-info-card--content">
        <div class="content-col">
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Name') }}</span>
            {{ getDetailText(customerDetails.created_by.display_name) }}
          </div>
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Email') }}</span>
            {{ getDetailText(customerDetails.email) }}
          </div>
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Phone') }}</span>
            {{ getDetailText(customerDetails.phone_number) }}
          </div>
        </div>
        <div class="content-col">
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Address') }}</span>
            {{ getDetailText(customerDetails.address) }}
          </div>
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Kvk') }}</span>
            {{ getDetailText(customerDetails.kvk) }}
          </div>
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Vat') }}</span>
            {{ getDetailText(customerDetails.btw) }}
          </div>
        </div>
        <div class="content-col">
          <!-- <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Status') }}</span>
            <span style="font-size: 14px;">
              {{ (controlPanelCustomerCompany.is_premium) ? 'PREMIUM': 'BASIC' }}
            </span>
          </div> -->
          <div class="content-col--item">
            <span class="content-col--label">{{ $gettext('Closing Period') }}</span>
            <div>
              {{ getDetailText(accountantConnection.closing_date) }}
              <GekkoButton
                @click="$emit('open-customer-settings', false)"
                variant="link"
                icon="fa fa-pencil"
                size="sm"
                class="d-inline-block text-blue px-1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GekkoButton from '@/components/GekkoButton'
import GkBadge from '@/components/GkBadge.vue'

import CompanyService from '@/store/services/company.service.js'

export default {
  name: 'CustomerOverview',
  components: { GekkoButton, GkBadge },
  props: {
    customerDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sectorOptions: [],
      logoUrl: null,
    }
  },
  computed: {
    ...mapGetters({
      accountantConnection: 'accountants/getCurrentAccountantConnection',
      controlPanelCustomerCompany: 'accountants/getControlPanelCustomerCompany',
    }),
    subscriptionDuration() {
      return this.controlPanelCustomerCompany?.accountant_branding?.subscription_duration
    },
    sectorText() {
      if (!this.customerDetails.sector) {
        return '-'
      }
      if (this.sectorOptions.length) {
        return this.sectorOptions.find((sector) => sector.key === this.customerDetails.sector).value
      } else {
        return this.customerDetails.sector
      }
    },
  },
  created() {
    CompanyService.getSectors().then((response) => {
      this.sectorOptions = response.data
    })
    if (this.customerDetails.id) {
      CompanyService.getCustomerCompany(this.customerDetails.id).then((response) => {
        this.logoUrl = response.data.logo
      })
    }
  },
  methods: {
    getDetailText(detailText) {
      if (!detailText) {
        return '-'
      } else {
        return detailText
      }
    },
  },
}
</script>

<style lang="scss">
.company-info-card {
  display: flex;
  flex-direction: row;
  border-radius: 12px;
  padding: 1rem;
  border: 1px solid $colorBorderDash;
  font-size: 16px;
  background: #f9f9f9;
  &--contentwrap {
    padding-left: 1rem;
    display: flex;
    flex-direction: column;
  }
  &--companyname {
    display: flex;
    flex-direction: column;
    h2 {
      margin: 0;
      font-size: 24px;
      line-height: 1;
    }
    h3 {
      margin: 0;
      font-size: 20px;
      line-height: 1;
    }
    .sector {
      color: #adadad;
    }
    margin-bottom: 5px;
  }
  &--content {
    display: flex;
    gap: 1rem;
    .content-col {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      line-height: 1.3;
      &:last-child {
        padding-left: 1rem;
      }
      &--item {
        display: flex;
        flex-direction: column;
      }
      &--label {
        text-transform: uppercase;
        color: $colorUnassigned;
        font-size: 14px;
      }
    }
  }
}
</style>